import PropTypes from 'prop-types';
import React from 'react';
import styles from './Layout.module.css';
export default function Layout(_a) {
    var children = _a.children;
    return (React.createElement("div", { className: styles.outer },
        React.createElement("div", { className: styles.inner }, children)));
}
Layout.propTypes = {
    children: PropTypes.node,
};
